module.exports = __webpack_public_path__ + "media/img/ms-icon-70x70-23e3b737472ac24821c26a2cf8bb481b.png";